import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { getGroupInvitation, loadGroup, loadGroupPublicView, addUserToGroup, archiveGroupInvitation } from "../../redux/actions/groupActions";
import LoadingPage from "../common/LoadingPage";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { toast } from "react-toastify";
import $ from 'jquery';
import { checkLogin } from '../../redux/actions/authActions';
import '../common/Layout.css';
import "./Group.css";


function JoinGroupPage({
    user,
    groupInvitation, 
    getGroupInvitation,
    archiveGroupInvitation,
    checkLogin,
    loadGroup,
    loadGroupPublicView,
    addUserToGroup,
    history,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [processingInvitation, setProcessingInvitation] = useState(false);
    const [group, setGroup] = useState({});
    const [activeLogin, setActiveLogin] = useState(null);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        document.title = "Join Group | JustGoRide";

        if (!user || !user.id) {
            checkLogin().then((result) => {
                setActiveLogin(result.isAuthenticated);
            });
        }
    }, []);

    useEffect(() => {
        if (activeLogin !== null) {
            loadInvitation();
        }
    }, [activeLogin]);

    useEffect(() => {
        if (group.id && user.id) {
            if (existingMember(group)) {
                archiveGroupInvitation(groupInvitation.code);
                history.push(`/groups/${group.id}`);
            }
        }
    }, [user, group]);

    function loadInvitation() {
        var urlParams = new URLSearchParams(window.location.search);
        var code = urlParams.get('ref');

        getGroupInvitation(code)
            .then(invite => {
                if (activeLogin) {

                    loadGroup(invite.groupId)
                        .then(group => {
                            setGroup(group);
                            setProcessing(false);
                        })
                        .catch(error => {
                            if (error.message === "401" || error.message === "404") {
                                history.push("/resourceunavailable");
                                return;
                            }
                            errors.onLoad = "Loading group failed: " + error;
                            setErrors(errors);
                            setProcessing(false);
                        });
                }
                else {
                    loadGroupPublicView(invite.groupId)
                        .then(group => {
                            setGroup(group);
                            setProcessing(false);
                        })
                        .catch(error => {
                            if (error.message === "401" || error.message === "404") {
                                history.push("/resourceunavailable");
                                return;
                            }
                            errors.onLoad = "Loading group failed: " + error;
                            setErrors(errors);
                            setProcessing(false);
                        });
                }
            })
            .catch(error => {
                if (error.message === "401" || error.message === "404") {
                    history.push("/resourceunavailable");
                    return;
                }
                errors.onLoad = "Loading invitation failed: " + error;
                setErrors(errors);
                setProcessing(false);
            });
    }

   
    function existingMember(group) {
        var userFound = false; 
        group.members.map(member => {
            if (member.userId.toUpperCase() == user.id.toUpperCase()) {
                userFound = true;
            }

        });
        group.administrators.map(admin => {
            if (admin.userId.toUpperCase() == user.id.toUpperCase()) {
                userFound = true;
            }
        });
        return userFound;     
    }
    

    function acceptInvite(e) {
        e.preventDefault();
        setProcessingInvitation(true);
        var subjectUser = { userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.hasAvatar }; 
        addUserToGroup(subjectUser, group.id)
            .then(() => {
                archiveGroupInvitation(groupInvitation.code);
                history.push(`/groups/${group.id}`);
                setProcessingInvitation(false);
                toast.success(`Welcome to ${group.name}`);
            })
            .catch((error) => {
                toast.error(`Failed to join group: ${error.message}`);
            })
    }

    function declineInvite(e) {
        e.preventDefault();
        setProcessingInvitation(true);
        archiveGroupInvitation(groupInvitation.code)
            .then(() => {
                history.push("/");
                setProcessingInvitation(false);
                toast.success(`Invitation Declined`);
            })
    }

    function logIn(e) {
        history.push(`/login?rtn=/groups/${group.id}`);
    }

    function signUp(e) {
        history.push(`/signup`);
    }

    return (
        processing ? <LoadingPage /> :
            <React.Fragment>
                <div className="auth-back-fill"></div>
                <div className="h-100 auth-background justify-content-center">
                    <div className="auth-container my-auto col-12 col-md-8 col-lg-6">
                        <div className="auth-logo">
                            <Link to="/" className="">
                                <img className="siteLogo" src="/resources/images/logo.png" alt="JustGoRide" />
                            </Link>
                        </div>
                        <div className="auth-control clearfix">
                            {errors.onLoad ?
                                <div className="load-failed">
                                    <div className="alert alert-danger" role="alert">
                                        Invitation not found
                                    </div>
                                    <p>
                                        This invitation appears to no longer be valid. Please contact the person who sent it to you to resolve the issue. 
                                    </p>
                                </div>
                                :
                                processingInvitation ? <Spinner /> :
                                <div className="group-invitation">
                                   
                                    <div className="invitation-header">
                                        <div className="avatar-container">
                                            {group.avatarAvailable ?
                                                <React.Fragment>
                                                    <UserAvatar className="default-avatar" size="75" name={`${group.name}`} src={`${apiConfig.API_URL}groups/avatar/${group.id}.png?v=${group.avatarVersion}`} />
                                                </React.Fragment>
                                                :
                                                <div className="default-avatar"><span className="fas fa-users"></span></div>
                                            }
                                        </div>
                                        <h3>{group.name}</h3>
                                    </div>
                                    <p>{`You have been invited to join ${group.name}`}</p>
                                    {user && user.id ?
                                        <React.Fragment>
                                            <div className="invited-user">
                                                <div className="invited-user-container">
                                                    {user.avatarAvailable ?
                                                        <UserAvatar className="user-avatar" size="60" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                        :
                                                        <div className="user-avatar default-avatar"><span className="fas fa-user" /></div>
                                                    }
                                                    <div className="user-details">
                                                        <span className="text-muted">You are logged in as</span>
                                                        <br />
                                                        {`${user.firstName} ${user.surname}`}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="actions">
                                                <button className="btn btn-link" onClick={declineInvite}>Decline</button>
                                                <button className="btn btn-info" onClick={acceptInvite}>Accept Invitation</button>
                                            </div>
                                        </React.Fragment>
                                        :
                                        <div>
                                            <p>
                                                If you want to accept this invitation and already have a JustGoRide account then
                                                just hit the Log In button below and we'll redirect you to the group. 
                                            </p>
                                            <p>
                                                If you don't have an account then signing up is quick and easy! Click on the
                                                Sign Up button to start! 
                                            </p>
                                            <div className="actions">
                                                <button className="btn btn-info btn-non-active" onClick={logIn}>Log In</button><br/>
                                                <button className="btn btn-info btn-non-active" onClick={signUp}>Sign Up</button><br />
                                                <button className="btn btn-link btn-non-active" onClick={declineInvite}>Decline Invitation</button>
                                            </div>    
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>

    );

}

JoinGroupPage.propTypes = {
    user: PropTypes.object.isRequired,
    groupInvitation: PropTypes.object.isRequired,
    checkLogin: PropTypes.func.isRequired,
    loadGroup: PropTypes.func.isRequired,
    loadGroupPublicView: PropTypes.func.isRequired,
    getGroupInvitation: PropTypes.func.isRequired,
    archiveGroupInvitation: PropTypes.func.isRequired,
    addUserToGroup: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
        user: state.user,
        groupInvitation: state.groupInvitation
    };
}

const mapDispatchToProps = {
    loadGroup,
    loadGroupPublicView,
    getGroupInvitation,
    archiveGroupInvitation,
    addUserToGroup,
    checkLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinGroupPage);



// WEBPACK FOOTER //
// ./src/components/groups/JoinGroupPage.js